// extracted by mini-css-extract-plugin
export default {"container":"CourseSelectionPage__container___RrDjZ"};